export const HEADER = {
  TOGGLE_USER_MENU: "TOGGLE_USER_MENU",
  TOGGLE_COMMON_MENU: "TOGGLE_COMMON_MENU",
  CLOSE_MENUS: "CLOSE_MENUS",
};
